var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnooBoxReceivedInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "33px",
    viewBox: "0 0 58 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.594,0.81 C1.068,1.197 0.784,1.768 0.745,2.522 L0.745,2.522 L0.744,2.551 C0.725,2.905 0.77,3.223 0.877,3.508 L0.877,3.508 C0.985,3.79 1.15,4.029 1.37,4.222 L1.37,4.222 C1.59,4.417 1.806,4.574 2.016,4.695 L2.016,4.695 C2.229,4.815 2.483,4.937 2.785,5.063 L2.785,5.063 C2.847,5.087 2.931,5.121 3.038,5.165 L3.038,5.165 C3.145,5.209 3.228,5.243 3.29,5.267 L3.29,5.267 C3.353,5.294 3.427,5.327 3.517,5.368 L3.517,5.368 C3.605,5.41 3.672,5.445 3.721,5.473 L3.721,5.473 C3.768,5.502 3.826,5.536 3.892,5.577 L3.892,5.577 C3.957,5.616 4.01,5.655 4.048,5.692 L4.048,5.692 C4.088,5.73 4.123,5.768 4.159,5.81 L4.159,5.81 C4.192,5.853 4.215,5.897 4.226,5.947 L4.226,5.947 C4.237,5.995 4.241,6.044 4.237,6.093 L4.237,6.093 L4.237,6.121 C4.217,6.504 3.92,6.667 3.343,6.613 L3.343,6.613 C2.722,6.553 2.081,6.263 1.42,5.74 L1.42,5.74 C1.308,5.651 1.173,5.601 1.021,5.587 L1.021,5.587 C0.797,5.565 0.6,5.632 0.434,5.783 L0.434,5.783 C0.268,5.935 0.178,6.132 0.166,6.37 L0.166,6.37 C0.149,6.695 0.267,6.955 0.52,7.153 L0.52,7.153 C1.336,7.815 2.23,8.192 3.202,8.284 L3.202,8.284 C4.03,8.361 4.71,8.216 5.24,7.849 L5.24,7.849 C5.77,7.482 6.056,6.888 6.099,6.065 L6.099,6.065 L6.1,6.037 C6.117,5.702 6.073,5.401 5.965,5.131 L5.965,5.131 C5.856,4.861 5.687,4.628 5.458,4.428 L5.458,4.428 C5.228,4.229 5.01,4.069 4.803,3.949 L4.803,3.949 C4.597,3.83 4.34,3.698 4.03,3.552 L4.03,3.552 C3.607,3.349 3.376,3.241 3.341,3.229 L3.341,3.229 C2.839,2.979 2.593,2.736 2.606,2.495 L2.606,2.495 L2.607,2.467 C2.616,2.315 2.687,2.195 2.823,2.106 L2.823,2.106 C2.958,2.017 3.147,1.987 3.391,2.009 L3.391,2.009 C3.805,2.049 4.318,2.259 4.933,2.644 L4.933,2.644 C5.056,2.723 5.179,2.768 5.305,2.78 L5.305,2.78 C5.54,2.801 5.74,2.736 5.906,2.584 L5.906,2.584 C6.072,2.431 6.162,2.236 6.174,1.997 L6.174,1.997 C6.193,1.626 6.046,1.337 5.73,1.134 L5.73,1.134 C5.011,0.674 4.274,0.407 3.517,0.335 L3.517,0.335 C3.4,0.324 3.286,0.319 3.174,0.319 L3.174,0.319 C2.566,0.319 2.039,0.483 1.594,0.81 L1.594,0.81 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.248,1.034 C1.038,1.225 0.927,1.473 0.91,1.78 L0.91,1.78 L0.617,7.454 C0.602,7.759 0.686,8.028 0.874,8.255 L0.874,8.255 C1.061,8.485 1.299,8.612 1.588,8.64 L1.588,8.64 C1.875,8.667 2.124,8.585 2.332,8.393 L2.332,8.393 C2.542,8.202 2.655,7.953 2.67,7.648 L2.67,7.648 L2.84,4.366 C2.866,3.861 3,3.483 3.245,3.239 L3.245,3.239 C3.488,2.992 3.807,2.888 4.204,2.925 L4.204,2.925 C4.599,2.963 4.899,3.125 5.102,3.413 L5.102,3.413 C5.303,3.7 5.392,4.099 5.365,4.605 L5.365,4.605 L5.196,7.886 C5.181,8.191 5.267,8.459 5.461,8.688 L5.461,8.688 C5.652,8.918 5.887,9.045 6.165,9.072 L6.165,9.072 C6.444,9.099 6.69,9.016 6.904,8.824 L6.904,8.824 C7.119,8.634 7.234,8.385 7.249,8.08 L7.249,8.08 L7.454,4.11 C7.5,3.221 7.32,2.504 6.914,1.956 L6.914,1.956 C6.508,1.409 5.917,1.099 5.144,1.026 L5.144,1.026 C4.333,0.95 3.604,1.294 2.96,2.059 L2.96,2.059 L2.963,1.973 C2.979,1.667 2.894,1.401 2.706,1.171 L2.706,1.171 C2.52,0.943 2.281,0.813 1.994,0.787 L1.994,0.787 C1.958,0.783 1.922,0.782 1.887,0.782 L1.887,0.782 C1.644,0.782 1.431,0.866 1.248,1.034 L1.248,1.034 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.232,1.572 C1.449,2.27 1.029,3.174 0.971,4.283 L0.971,4.283 L0.97,4.311 C0.912,5.428 1.239,6.409 1.95,7.254 L1.95,7.254 C2.663,8.099 3.576,8.575 4.693,8.679 L4.693,8.679 C5.81,8.784 6.76,8.489 7.542,7.789 L7.542,7.789 C8.324,7.09 8.744,6.186 8.802,5.079 L8.802,5.079 L8.804,5.05 C8.861,3.932 8.534,2.951 7.822,2.105 L7.822,2.105 C7.111,1.262 6.197,0.786 5.08,0.681 L5.08,0.681 C4.934,0.667 4.79,0.66 4.65,0.66 L4.65,0.66 C3.717,0.66 2.91,0.964 2.232,1.572 L2.232,1.572 Z M4.763,6.799 C4.197,6.746 3.752,6.503 3.431,6.069 L3.431,6.069 C3.108,5.635 2.964,5.122 2.994,4.531 L2.994,4.531 L2.996,4.502 C3.026,3.92 3.23,3.437 3.606,3.055 L3.606,3.055 C3.983,2.673 4.451,2.509 5.01,2.561 L5.01,2.561 C5.576,2.614 6.022,2.858 6.343,3.291 L6.343,3.291 C6.664,3.724 6.809,4.237 6.779,4.83 L6.779,4.83 L6.778,4.859 C6.747,5.442 6.543,5.924 6.167,6.305 L6.167,6.305 C5.835,6.641 5.435,6.809 4.964,6.809 L4.964,6.809 C4.898,6.809 4.832,6.805 4.763,6.799 L4.763,6.799 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.471,1.348 C0.688,2.048 0.269,2.951 0.211,4.06 L0.211,4.06 L0.21,4.088 C0.152,5.206 0.479,6.187 1.19,7.032 L1.19,7.032 C1.901,7.877 2.817,8.351 3.934,8.457 L3.934,8.457 C5.049,8.562 5.998,8.266 6.78,7.566 L6.78,7.566 C7.564,6.867 7.984,5.964 8.04,4.856 L8.04,4.856 L8.042,4.827 C8.1,3.709 7.773,2.728 7.062,1.883 L7.062,1.883 C6.35,1.039 5.436,0.563 4.319,0.458 L4.319,0.458 C4.173,0.445 4.03,0.438 3.89,0.438 L3.89,0.438 C2.957,0.438 2.151,0.742 1.471,1.348 L1.471,1.348 Z M4.002,6.576 C3.435,6.523 2.991,6.28 2.67,5.847 L2.67,5.847 C2.349,5.413 2.204,4.9 2.234,4.309 L2.234,4.309 L2.235,4.28 C2.266,3.697 2.469,3.215 2.846,2.833 L2.846,2.833 C3.224,2.45 3.691,2.285 4.25,2.338 L4.25,2.338 C4.817,2.391 5.26,2.635 5.582,3.068 L5.582,3.068 C5.903,3.502 6.049,4.015 6.017,4.608 L6.017,4.608 L6.016,4.636 C5.986,5.218 5.783,5.701 5.407,6.082 L5.407,6.082 C5.074,6.419 4.673,6.586 4.203,6.586 L4.203,6.586 C4.137,6.586 4.07,6.583 4.002,6.576 L4.002,6.576 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.998,1.397 C0.984,1.672 1.193,1.914 1.469,1.939 L1.469,1.939 C1.531,1.944 1.59,1.938 1.646,1.923 L1.646,1.923 L1.651,1.822 C1.598,1.843 1.537,1.852 1.474,1.847 L1.474,1.847 C1.254,1.827 1.085,1.63 1.097,1.406 L1.097,1.406 C1.109,1.181 1.298,1.016 1.519,1.036 L1.519,1.036 C1.581,1.042 1.639,1.06 1.689,1.091 L1.689,1.091 L1.695,0.989 C1.642,0.964 1.584,0.948 1.524,0.943 L1.524,0.943 C1.508,0.942 1.494,0.941 1.479,0.941 L1.479,0.941 C1.223,0.941 1.012,1.137 0.998,1.397 L0.998,1.397 Z M1.281,1.686 L1.382,1.694 L1.392,1.504 L1.528,1.516 L1.616,1.716 L1.657,1.719 L1.664,1.582 L1.629,1.511 C1.643,1.508 1.656,1.502 1.669,1.495 L1.669,1.495 L1.684,1.199 C1.655,1.177 1.617,1.164 1.572,1.159 L1.572,1.159 L1.31,1.137 L1.281,1.686 Z M1.56,1.422 L1.398,1.408 L1.408,1.24 L1.57,1.254 C1.622,1.258 1.652,1.284 1.65,1.347 L1.65,1.347 C1.646,1.403 1.61,1.423 1.57,1.423 L1.57,1.423 C1.567,1.423 1.563,1.422 1.56,1.422 L1.56,1.422 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00414113434,4.65325328 C0.00414113434,7.22226191 2.0849369,9.30484869 4.6517362,9.30484869 L4.6517362,9.30484869 C7.21853549,9.30484869 9.29933126,7.22226191 9.29933126,4.65325328 L9.29933126,4.65325328 C9.29933126,2.08428611 7.21853549,0.0016578795 4.6517362,0.0016578795 L4.6517362,0.0016578795 C2.0849369,0.0016578795 0.00414113434,2.08428611 0.00414113434,4.65325328 L0.00414113434,4.65325328 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00455524777,3.90733185 C0.00455524777,6.47625758 2.08522678,8.55876147 4.65198467,8.55876147 L4.65198467,8.55876147 C6.27506086,8.55876147 7.7019301,7.72480663 8.53309718,6.46282876 L8.53309718,6.46282876 C7.79999217,6.94647365 6.92335544,7.22980526 5.97979798,7.22980526 L5.97979798,7.22980526 C3.41312292,7.22980526 1.33232715,5.14725993 1.33232715,2.57837564 L1.33232715,2.57837564 C1.33232715,1.63392314 1.61541509,0.756531862 2.09864406,0.0228787371 L2.09864406,0.0228787371 C0.837792887,0.85480267 0.00455524777,2.28285862 0.00455524777,3.90733185 L0.00455524777,3.90733185 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0252195081,4.98495352 C0.0252195081,7.72124219 2.24938135,9.94731844 4.983234,9.94731844 L4.983234,9.94731844 C7.71708666,9.94731844 9.94120708,7.7211593 9.94120708,4.98495352 L9.94120708,4.98495352 C9.94120708,2.24874775 7.71708666,0.0227129491 4.983234,0.0227129491 L4.983234,0.0227129491 C2.24938135,0.0227129491 0.0252195081,2.24874775 0.0252195081,4.98495352 L0.0252195081,4.98495352 Z M0.646389658,4.98495352 C0.646389658,2.59155579 2.59181175,0.644376314 4.983234,0.644376314 L4.983234,0.644376314 C7.37457344,0.644376314 9.32003693,2.59155579 9.32003693,4.98495352 L9.32003693,4.98495352 C9.32003693,7.37835126 7.37457344,9.32553073 4.983234,9.32553073 L4.983234,9.32553073 C2.59185316,9.32553073 0.646389658,7.37835126 0.646389658,4.98495352 L0.646389658,4.98495352 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60258093,0.120776522 L2.000582,2.72509798 L0.560461121,1.2836132 C0.439084474,1.16221498 0.242463415,1.16221498 0.121169591,1.2836132 L0.121169591,1.2836132 C-8.28226867e-05,1.40496998 -8.28226867e-05,1.60184317 0.121169591,1.72319995 L0.121169591,1.72319995 L1.78097764,3.38443666 C1.83928481,3.44275257 1.91825625,3.47549569 2.00062341,3.47549569 L2.00062341,3.47549569 C2.08303198,3.47549569 2.16200341,3.44275257 2.22026917,3.38443666 L2.22026917,3.38443666 L5.04195529,0.560363271 C5.1632077,0.438965044 5.1632077,0.242133301 5.04195529,0.120776522 L5.04195529,0.120776522 C4.98124626,0.0600566849 4.90177789,0.02971749 4.82226811,0.02971749 L4.82226811,0.02971749 C4.74275833,0.02971749 4.66324855,0.0600566849 4.60258093,0.120776522 L4.60258093,0.120776522 Z",
    id: "path-17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snoo_rental",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hbi_rental_acc_overview_order_delivered_rename",
    transform: "translate(-927.000000, -267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(191.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(699.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(37.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#8C8C8C",
    points: "48.2186 5.2385 47.7666 28.8695 56.5346 23.9455 56.9366 2.8775"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#9F9F9F",
    points: "1.1558 23.2988 47.7718 28.8468 48.2248 5.2168 1.1558 2.0408"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#B3B3B3",
    points: "1.1495 2.0634 48.2185 5.2384 56.9365 2.8774 13.6745 0.1524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1499,2.063 L40.9549,4.749",
    id: "Stroke-4",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6748,0.1523 L56.9368,2.8773",
    id: "Stroke-5",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1499,23.3203 L47.7669,28.8693",
    id: "Stroke-6",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1499,2.063 L1.1499,23.32",
    id: "Stroke-7",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2187,5.2388 L47.8437,24.8358",
    id: "Stroke-8",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.937,2.8774 L56.534,23.9454",
    id: "Stroke-9",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1499,2.063 L13.6749,0.152",
    id: "Stroke-10",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2187,5.2388 L56.9367,2.8778",
    id: "Stroke-11",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7666,28.8696 L56.5346,23.9456",
    id: "Stroke-12",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2725,4.9624 L48.2185,5.2384",
    id: "Stroke-13",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8169,26.2578 L47.7669,28.8698",
    id: "Stroke-14",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-4.835 13.304 11.176 13.304 11.176 -4.681 -4.835 -4.681"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "-4.385 14.076 12.461 14.076 12.461 -4.219 -4.385 -4.219"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(22.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "-4.037 13.701 13.81 13.701 13.81 -4.34 -4.037 -4.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(31.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#FFFFFF",
    mask: "url(#mask-8)",
    points: "-4.797 13.478 13.049 13.478 13.049 -4.563 -4.797 -4.563"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(38.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#FFFFFF",
    mask: "url(#mask-10)",
    points: "-4.002 6.941 6.998 6.941 6.998 -4.059 -4.002 -4.059"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(43.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.686085, 0.648684)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#C4C5C7",
    mask: "url(#mask-12)",
    points: "-0.202915582 9.51208363 9.50638798 9.51208363 9.50638798 -0.205577058 -0.202915582 -0.205577058"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.686085, 1.394730)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#B4B6B8",
    mask: "url(#mask-14)",
    points: "-0.202501469 8.7659964 8.74015389 8.7659964 8.74015389 -0.1843562 -0.202501469 -0.1843562"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.354794, 0.317108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#6B6B6B",
    mask: "url(#mask-16)",
    points: "-0.181837209 10.1545119 10.1482638 10.1545119 10.1482638 -0.184521988 -0.181837209 -0.184521988"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(2.839475, 3.798655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#6B6B6B",
    mask: "url(#mask-18)",
    points: "-0.176826436 3.68273063 5.33995131 3.68273063 5.33995131 -0.177517447 -0.176826436 -0.177517447"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooBoxReceivedInactive);
export default __webpack_public_path__ + "static/media/snoo-box-received-inactive.d92ddc97bbfa5ecb4fe7d4d304a5aaf6.svg";
export { ForwardRef as ReactComponent };